















































import { notify } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { HasTaskMixin } from '@/mixins';
import { DetailedEmailCampaign, EmailCampaignNotes } from '@/types';
import FetchStatus from '../FetchStatus.vue';
import Notes from '../Notes.vue';
import SummaryCards from './SummaryCards.vue';
import { submitNotes } from '../email-campaign';

export default HasTaskMixin.extend({
  props: {
    emailCampaign: {
      type: Object as () => DetailedEmailCampaign,
      required: true,
    },
  },
  methods: {
    updateNotes(notes: EmailCampaignNotes): void {
      this.emailCampaign.notes = notes;
    },
    submit(): void {
      this.task = submitNotes(this.emailCampaign.id);
      this.task.then(() => {
        notify.success('Report with notes has been sent to subscribers and report recipients.');
      });
    },
    isGranted,
  },
  components: {
    'fetch-status': FetchStatus,
    notes: Notes,
    'summary-cards': SummaryCards,
  },
});
